<ng-template #iconForFlight let-transportType="transportType" let-type="type">
  <fcom-icon [name]="mapTransportTypeToIcon[transportType][type]" class="ms-xxsmall-b nordic-blue-900-text"></fcom-icon>
</ng-template>

<ng-template #iconForStopover>
  <fcom-icon [name]="SvgLibraryIcon.STOPOVER" class="ms-xxsmall-b nordic-blue-900-text"></fcom-icon>
</ng-template>

<div class="bound" [class.is-last]="last">
  <div class="flex bound-card-wrapper">
    <div class="wrapper flex flex--row">
      <div class="bound-graph ms-xsmall-r flex flex--column flex--center">
        <ng-container
          *ngTemplateOutlet="
            showAsStopOver(flight, 'departure') ? iconForStopover : iconForFlight;
            context: {
              type: 'departure',
              transportType: flight.segmentInfo.transportType,
            }
          "
        ></ng-container>
        <div class="bound-graph-line relative nordic-blue-900-bg flex-1"></div>
        <ng-container
          *ngTemplateOutlet="
            showAsStopOver(flight, 'arrival') ? iconForStopover : iconForFlight;
            context: {
              type: 'arrival',
              transportType: flight.segmentInfo.transportType,
            }
          "
        ></ng-container>
      </div>
      <div class="itinerary-box ms-xlarge-r font-body-1 flex flex--column">
        <div class="relative flex-1">
          <div class="flex flex--column">
            <div class="itinerary-line break-word ps-xsmall-b">
              <span class="bold-type">{{ flight.segmentInfo.departureDateTime | finTime }}</span>
              {{ flight.segmentInfo.boardPoint | finLocationName }}
            </div>
            <fcom-tag
              *ngIf="getFlightTypeI18n(flight.segmentInfo.cabin, flight.segmentInfo.transportType) as transportTypeI18n"
              [attr.data-cabin]="flight.segmentInfo.cabin"
              [attr.data-transportType]="flight.segmentInfo.transportType"
            >
              <span [class.strike-through]="(currentStage$ | async) === Stage.REVIEW && (flightInBasket$ | async)">
                {{ transportTypeI18n | finLocalization }}
              </span>
            </fcom-tag>
            <ng-container
              *ngIf="(currentStage$ | async) === Stage.REVIEW && (flightInBasket$ | async) as flightInBasket"
            >
              <fcom-tag
                *ngIf="
                  getFlightTypeI18n(flightInBasket.cabin, flightInBasket.flight.segmentInfo.transportType) as cabin
                "
                class="ms-xsmall-t"
                [attr.data-upgraded-cabin]="flightInBasket.cabin"
                data-testid="upgraded-cabin"
              >
                {{ cabin | finLocalization }}
              </fcom-tag>
            </ng-container>
          </div>
        </div>
        <div class="relative ps-xsmall-t">
          <span class="bold-type">{{ flight.segmentInfo.arrivalDateTime | finTime }}</span>
          {{ flight.segmentInfo.offPoint | finLocationName }}
        </div>
      </div>
    </div>

    <div class="flex flex-1" [ngClass]="highlighted ? 'flex--row' : 'flex--column'">
      <div class="font-body-1 ps-xsmall-b" *ngIf="(currentStage$ | async) === Stage.FLIGHTS">
        <span *ngIf="numberOfFlights > 1" class="bold-type"
          >{{ flight.segmentInfo.ordinal }}/{{ numberOfFlights }}&nbsp;</span
        >
        <span *ngIf="(currentStage$ | async) === Stage.FLIGHTS">{{
          'oneUpgrade.selectTravelClass' | finLocalization
        }}</span>
      </div>
      <div
        class="rounded-large flex flex-1 flex--column"
        [ngClass]="{
          'border pr-small': bordered,
          'grey-100-bg': highlighted,
        }"
      >
        <span class="is-vishidden" *ngIf="!(first && last) && (currentStage$ | async) === Stage.FLIGHTS">
          {{
            'oneUpgrade.aria.upgradeOptionsInfo'
              | finLocalization
                : {
                    journeyIndex: flight.segmentInfo.group,
                    legIndex: flight.segmentInfo.ordinal,
                  }
          }}
        </span>

        <span class="is-vishidden" *ngIf="(currentStage$ | async) === Stage.REVIEW">
          {{
            'oneUpgrade.aria.selectedUpgradeInfo'
              | finLocalization
                : {
                    journeyIndex: flight.segmentInfo.group,
                    legIndex: flight.segmentInfo.ordinal,
                  }
          }}
        </span>

        <span class="is-vishidden" *ngIf="!(first && last) || (currentStage$ | async) === Stage.REVIEW">
          {{
            'oneUpgrade.aria.flightInfo'
              | finLocalization
                : {
                    departure: flight.segmentInfo.boardPoint | finLocationName,
                    departureDate: flight.segmentInfo.departureDateTime | finDateFormat: 'FULL_NO_YEAR',
                    departureTime: flight.segmentInfo.departureDateTime | finTime,
                    arrival: flight.segmentInfo.offPoint | finLocationName,
                    arrivalDate: flight.segmentInfo.arrivalDateTime | finDateFormat: 'FULL_NO_YEAR',
                    arrivalTime: flight.segmentInfo.arrivalDateTime | finTime,
                  }
          }}
        </span>

        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div *ngIf="!last" class="ms-xsmall-y bound-separators border-bottom-dashed ms-medium-y"></div>
</div>
